module.exports = __webpack_public_path__ + "media/images/ship-1942e9c4205815673c3bd6b87b447f50.png";